
        import { optionalAuth, authGuard } from './js/modules/auth-guard.ts';

        document.addEventListener('DOMContentLoaded', async () => {
            const signinBtn = document.getElementById('signin-btn');
            const signupBtn = document.getElementById('signup-btn');
            const signupBtnBottom = document.getElementById('signup-btn-bottom');
            const authSection = document.getElementById('auth-section');

            await optionalAuth({
                onAuthReady: (user, isAuthenticated) => {
                    if (isAuthenticated) {
                        window.location.href = 'projects.html';
                    }
                },
            });

            signinBtn.addEventListener('click', () => {
                window.location.href = 'signin.html';
            });

            signupBtn.addEventListener('click', () => {
                window.location.href = 'signup.html';
            });

            signupBtnBottom.addEventListener('click', () => {
                window.location.href = 'signup.html';
            });
        });
    